import React from "react";
import { connect } from "react-redux";

import { isAnyPendingParentalConsentItemSaved } from "state/school_money/selectors";
import { clearSavedPendingParentalConsentItems } from "state/school_money/actions";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./ParentalConsentSuccessModal.css";

class ParentalConsentSuccessModal extends React.Component {
  
  render() {
    return (
      <ModalDialog isOpen={this.props.isOpen}>
        <div className="parental-consent-success">
          <div className="parental-consent-success__title">Consent Saved</div>
          <div className="parental-consent-success__message">Consent saved successfully.</div>
          <div className="parental-consent-sucess__button-container">
            <Button className="parental-consent-success__close-button" onClick={this.props.onClose}>OK</Button>
          </div>
        </div>
      </ModalDialog>
    );
  }
  
}

export default connect(
  state => ({
    isOpen: isAnyPendingParentalConsentItemSaved(state)
  }),
  {
    onClose: clearSavedPendingParentalConsentItems
  }
)(ParentalConsentSuccessModal);



// WEBPACK FOOTER //
// ./src/components/school_money/parental_consent/ParentalConsentSuccessModal.js